// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IFX-1","content":"styles_content__2NtAP","tableWrap":"styles_tableWrap__BQ8BY"};